export default "__VITE_ASSET__9d845003__"